import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ENDPOINTS } from "../../../js/api/_config";


export const getTimezoneList = createAsyncThunk('/getTimezoneList', async (data, { rejectWithValue }) => {

    try {
        const response = await axios.get(ENDPOINTS.CLINIC.TIMEZONE)
        return response.data;
    } catch (error) {
        return rejectWithValue(
            error.response?.data ||
            "Something went wrong while fetching the buyer profile."
        );
    }
})

const initialState = {
    data: [],
    isLoading: true,
    error: null,
};

const getTimezoneListSlice = createSlice(
    {
        name: "timezone",
        initialState,
        extraReducers: (builder) => {
            builder.addCase(getTimezoneList.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.isLoading = false;
                state.error = null;
            })
                .addCase(getTimezoneList.pending, (state) => {
                    state.isLoading = true;
                    state.error = null;
                })
                .addCase(getTimezoneList.rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.payload;
                })
        }
    }
)

export default getTimezoneListSlice.reducer;